// var host = "https://api-v2.createquickcv.com/api";
var host = "https://api-staging-quickcv.bitflex.xyz/api";

const { h } = require("vue");

module.exports = {
    V1API: {
        // QuickCV
        'getAccessToken': host + '/authentication/token/admin',
        'refreshAccessToken': host + '/authentication/token/refresh',
        'verifyLogin': host + '/authentication/token/verify',

        // Dashboard
        'get_dashboard_count': host + '/dashboard/count',

        // API Key
        'get_key': host + '/settings/site/view',
        'create_key': host + '/settings/site/update',

        // Prompt Category
        'prompt_category_list': host + '/prompt/categories',
        'create_prompt_category': host + '/prompt/categories/create',
        'update_prompt_category': host + '/prompt/categories/update/',
        'prompt_category_delete': host + '/prompt/categories/delete/',

        // Prompt Template
        'prompt_template_list': host + '/prompt/templates',
        'create_prompt_template': host + '/prompt/templates/create',
        'update_prompt_template': host + '/prompt/templates/update/',
        'prompt_template_delete': host + '/prompt/templates/delete/',
        'prompt_template_toggle': host + '/prompt/templates/toggle/',

        // Sidebar Menu
        'update_sidebar_toggle': host + '/sidebar/toggle/',
        'sidebar_list': host + '/sidebar/',
        'main_toggle_value': host + '/settings/site/view',
        'update_main_toggle': host + '/settings/site/sidebar/toggle',

        // Course
        'course_category_list': host + '/courses/category/',
        'course_category_parent': host + '/courses/category/parent',
        'course_category_list_by_parent': host + '/courses/sub-category/by-category/',
        'create_course_category': host + '/courses/category/create',
        'update_course_category': host + '/courses/category/update/',
        'course_category_delete': host + '/courses/category/delete/',
        'course_list': host + '/courses/',
        'create_course': host + '/courses/create',
        'update_course': host + '/courses/update/',
        'course_delete': host + '/courses/delete/',

        // Course Partner
        'partner_list': host + '/courses/partner',
        'create_partner': host + '/courses/partner/create',
        'update_partner': host + '/courses/partner/edit/',
        'partner_delete': host + '/courses/partner/delete/',

        // E-Book
        'e_book_list': host + '/ebook/',
        'create_e_book': host + '/ebook/create',
        'update_e_book': host + '/ebook/update/',
        'e_book_delete': host + '/ebook/delete/',

        // Feedback
        'feedback_list': host + '/feedback/list',
        'feedback_delete': host + '/subscription/pack/delete/',

        // Package
        'package_list': host + '/subscription/admin-site/pack/admin-list',
        'create_package': host + '/subscription/pack/create',
        'update_package': host + '/subscription/pack/edit/',
        'package_delete': host + '/subscription/pack/delete/',

        // Coupon
        'coupon_list': host + '/coupons/',
        'create_coupon': host + '/coupons/create',
        'update_coupon': host + '/coupons/update/',
        'coupon_delete': host + '/coupons/delete/',

        // Coin
        'coin_list': host + '/coin-wallet/feature-costs/dash',
        'create_coin': host + '/coin-wallet/feature-costs/create',
        'update_coin': host + '/coin-wallet/feature-costs/edit/',
        'coin_delete': host + '/coin-wallet/feature-costs/delete/',

        // Subscriber
        'subscriber_list': host + '/dashboard/regular-premium/list',
        'payment_initiated_list': host + '/dashboard/unpaid/list',
        'expiring_soon_list': host + '/dashboard/expiring-subscription/list',
        'activated_list': host + '/dashboard/paid-active/list',
        'expired_list': host + '/dashboard/expired/list',
        'subscriber_history': host + '/dashboard/user/wallet-history',
        'subscriber_delete': host + '/authentication/delete/',

        // Payment Log
        'payment_log_list': host + '/dashboard/payment-log/list',
        'payment_details': host + '/location/shelter/details/',
        'create_payment': host + '/location/shelter/create',
        'update_payment': host + '/location/shelter/edit/',
        'payment_delete': host + '/location/shelter/delete/',

        // Label
        'label_list': host + '/jd-tracking/dashboard/label-list',
        'create_label': host + '/jd-tracking/dashboard/label-create',
        'update_label': host + '/jd-tracking/dashboard/label-update/',
        'label_delete': host + '/jd-tracking/dashboard/label-delete/',

        // Language
        'language_list': host + '/additional-qualification/languages/list',
        'create_language': host + '/additional-qualification/languages/add',
        'update_language': host + '/additional-qualification/languages/update/',
        'language_delete': host + '/additional-qualification/languages/delete/',

        // Digital Skill
        'skill_list': host + '/additional-qualification/skills/list',
        'create_skill': host + '/additional-qualification/skills/add',
        'update_skill': host + '/additional-qualification/skills/update/',
        'skill_delete': host + '/additional-qualification/skills/delete/',




        // Volunteer
        'volunteer_list': host + '/volunteer/accounts/list',
        'create_volunteer': host + '/volunteer/accounts/create',
        'update_volunteer': host + '/volunteer/accounts/edit/full/',
        'volunteer_delete': host + '/access-control/user-accounts/delete/',

        // House
        'house_list': host + '/home/list/admin-panel/full-list',
        'create_house': host + '/home/register',
        'other_member_delete': host + '/home/delete-listed/other-members',
        'other_member_edit': host + '/home/update-information/other-member/',
        'core_member_edit': host + '/home/update-information/core-member/',

        // Emergency Contact
        'contact_list': host + '/resource/contact',
        'create_contact': host + '/resource/contact/create',
        'update_contact': host + '/resource/contact/edit/',
        'contact_delete': host + '/resource/contact/delete/',

        // Relief
        'relief_list': host + '/resource/relief',
        'create_relief': host + '/resource/relief/create',
        'update_relief': host + '/resource/relief/edit/',
        'relief_delete': host + '/resource/relief/delete/',

        // Occupancy Summary
        'occupancy_summary_list': host + '/disaster-occupancy/all/sorted',

        //Portfolio
        // Blog
        'blog_list': host + '/blog/list',
        'create_blog': host + '/blog/create',
        'get_blog_details': host + '/blog/getdetail/slug',
        'update_blog': host + '/blog/update/',
        'blog_delete': host + '/blog/delete/',

        // Media Appearances
        'media_list': host + '/media_appearance/list',
        'create_media': host + '/media_appearance/create',
        'get_media_details': host + '/media_appearance/detail/slug',
        'update_media': host + '/media_appearance/update/',
        'media_delete': host + '/media_appearance/delete/',

        //Collaboration
        'collaboration_list': host + '/collaboration/list',
        'create_collaboration': host + '/collaboration/create',
        'get_collaboration_details': host + '/collaboration/getdetail/',
        'update_collaboration': host + '/collaboration/update/',
        'collaboration_delete': host + '/collaboration/delete/',

        // Gallery
        'gallery_list': host + '/gallery/list',
        'create_gallery': host + '/gallery/create',
        'get_gallery_details':host + '/gallery/detail/',
        'update_gallery': host + '/gallery/update/',
        'gallery_delete': host + '/gallery/delete/',

        //Publications
        'publication_list': host + '/publication/',
        'create_publication': host + '/publication/create',
        'get_publication_details': host + '/publication/detail/',
        'update_publication': host + '/publication/update/',
        'publication_delete': host + '/publication/delete/',
        'publication_category': host + '/publication/category/list',

        // Recents
        'recent_list': host + '/recent/list',
        'create_recent': host + '/recent/create',
        'get_recent_details': host + '/recent/getdetail/',
        'update_recent': host + '/recent/update/',
        'recent_delete': host + '/recent/delete/'
    }
};
